import { render, staticRenderFns } from "./expertMembers.vue?vue&type=template&id=2e125bb8&scoped=true"
import script from "./expertMembers.vue?vue&type=script&lang=js"
export * from "./expertMembers.vue?vue&type=script&lang=js"
import style0 from "./expertMembers.vue?vue&type=style&index=0&id=2e125bb8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e125bb8",
  null
  
)

export default component.exports